import { render, staticRenderFns } from "./AvatarInput.vue?vue&type=template&id=233c7fc9&scoped=true"
import script from "./AvatarInput.vue?vue&type=script&lang=js"
export * from "./AvatarInput.vue?vue&type=script&lang=js"
import style0 from "./AvatarInput.vue?vue&type=style&index=0&id=233c7fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c7fc9",
  null
  
)

export default component.exports